// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
    box-sizing: border-box;
}

:root {
    --icon-vk: #07f;
    --icon-vk-hover: #006be5;
    --icon-youtube: red;
    --icon-youtube-hover: #e50000;
    --icon-discord: #5865f2;
    --icon-discord-hover: #4856f0;
    --color-accent: #0af;
    --color-background: white;
    --stroke-width: calc(1em / 16);
    --font-size: 10vmin;
    --font-weight: 700;
    --letter-spacing: calc(1em / 8);
    --max_width_roulete: 999px;
    --min_height_roulete: 600px;
}
.Main_wrapperSection__t9h9q{
    display: flex;
    flex-direction: column;
    gap:10px;

}
.Main_wrapperHeader__T8FMl{
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.Main_wrapperHeader__T8FMl .Main_buttonAll__JaDAF{
    border:1px solid rgb(7, 196, 7);
    color:rgb(9, 185, 9);
    font-family: monospace,sans-serif;
    padding: 10px;
    border-radius: 10px;
    cursor: pointer;
    font-size: 16px;
    transition: all 300ms cubic-bezier(0.420, 0.000, 0.580, 1.000)

}
.Main_wrapperHeader__T8FMl .Main_buttonAll__JaDAF:hover{
    border:1px solid greenyellow;
    color:greenyellow;
    transform: scale(1.1);
}

.Main_wrapperSection__t9h9q .Main_header__hUhxT{
    font-size: 25px;
    font-family: monospace , sans-serif;
    cursor: pointer;
    transition: all 300ms cubic-bezier(0.420, 0.000, 0.580, 1.000)
    


}
.Main_wrapperSection__t9h9q .Main_header__hUhxT:hover{
    color:greenyellow;
}
.Main_mainContainer__WJ\\+1L {
    

    display: flex;

    flex-direction: column;
    padding: 0 30px 0 30px;
    gap: 20px;

    min-height: 100vh;
}

.Main_card__RSCgW {
    position: relative;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    width: 24%;
    aspect-ratio: 1 / 1;
    border-radius: 10px;
    border: 1px solid #ffffff40;
    overflow: hidden;
    transition: transform 1s ease;
    padding: 20px;
}
.Main_naming__HTkHX{
    display: none;
    color: white;
    font-family: Poppins, sans-serif;
    font-weight: 600;
    font-size: 30px;
}
.Main_containerBlocks__0aV1u {
    margin-bottom: 70px;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    background: #ef00ff2e;
    padding: 20px;
    border-radius: 10px;
    border: 1px solid #ffffff1c;
}

.Main_card_image__TsD8H {
    position: absolute;
    top:0;
    left:0;

    width: 100%;
    height: 100%;

    overflow: hidden;
}

.Main_containerSlots__7ADSj {
    position: relative;
    display: flex;
    flex-direction: column;
    background-color: #1d2354;

    overflow: hidden;


    border-radius: 10px;

    cursor: pointer;
    padding: 20px;




}
.Main_containerImgs__SycFC{

    display: flex;
    justify-content: center;
    gap:10px;
    z-index: 2;

}
.Main_iconCompanyCard__kThTW{
    position: absolute;
    right: 0;
    top:0;
    font-size: 40px;
    color:greenyellow;
    rotate: 45deg;
    z-index: 2;
    margin:10px;
}
.Main_containerImgs__SycFC img{
    width: 200px;
}

.Main_buttonEnter__Nfve2 {


    background-color: #710cff;

    padding: 5px 50px;
    text-align: center;

    transition: 0.5s;

    color: white;
    font-family: Poppins, sans-serif;
    letter-spacing: 0.1rem;
    font-weight: 700;
    font-size: 20px;
    cursor: pointer;

    border-radius: 10px;
    display: block;



}
.Main_buttonEnter__Nfve2.Main_companyBlock__dpT2o{
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    background: #000000c4;
    z-index: 2;
    font-size: 15px !important;
    font-weight: 500;
}

.Main_containerName__yX5NX {
    color: white;
    font-family: Gilroy, sans-serif;
    font-weight: 600;
    font-size: 30px;
}

.Main_containerInf__tgFZj {
    display: flex;
    justify-content: space-between;
    align-items: center;
    z-index: 2;
    margin-bottom: 10px;
}

.Main_BgCont__Mwui8 {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    opacity: 0.2;
    transition: transform 0.5s ease; /* добавляем плавный переход для свойства transform */


}
.Main_containerSlots__7ADSj:hover .Main_BgCont__Mwui8{
    transform: scale(1.3); /* при наведении, увеличиваем изображение на 10% */
}

.Main_card_image__TsD8H img {
    width: 100%;
    height: 100%;
    object-fit: cover;

}
.Main_imgSlot__lEJmm img{
    width: 180px;
    border-radius: 10px;
}
.Main_wrapper__5oEWu{
    display: flex;
    gap:10px;

    justify-content: center;
}
.Main_containerCarosel__MgvRk{
    overflow: hidden;
    border-radius: 10px; 
    width: 100%;

}

.Main_card_title__k3OKO {
    padding: 10px;
    background-color: #191d3e;
    text-align: center;
    font-weight: bold;
    color: whitesmoke;
    font-size: 30px;

    font-family: Gilroy, sans-serif;
    font-weight: 700;
}

.Main_header__hUhxT {
    display: flex;
    color: whitesmoke;
    font-size: 30px;

    font-family: Gilroy, sans-serif;
    font-weight: 700;
}

.Main_button_enter_card__tAi9F {


    display: flex;
    justify-content: center;
    color: #fff;
    text-decoration: none;
    text-transform: uppercase;
    border-radius: 10px;
    border: none;
    letter-spacing: 0.1rem;
    font-size: 1rem;
    padding: 0.5rem 1.5rem;

    transition: 0.2s;

}

.Main_button_enter_card__tAi9F span {
    font-family: Poppins, sans-serif;
    font-weight: 700;
}
@media only screen and (max-width: 1700px) {
    .Main_imgSlot__lEJmm img{
        width:140px;
    }
}
@media only screen and (max-width: 1400px) {
    .Main_imgSlot__lEJmm img{
        width:120px;
    }
    .Main_containerName__yX5NX{
        font-size: 20px;
    }
    .Main_buttonEnter__Nfve2{
        padding: 5px 25px;
    }
}
@media only screen and (max-width: 1200px) {
    .Main_imgSlot__lEJmm img{
        width:110px;
    }
    
}
@media only screen and (max-width: 1000px)  {
    .Main_mainContainer__WJ\\+1L {
        margin-top: 60px;
        margin-left: 0;
        justify-content: center;
        padding: 10px;
        /*padding: 20px;*/

    }
    .Main_wrapper__5oEWu{
        flex-wrap: wrap;
    }
    .Main_buttonEnter__Nfve2{
        padding: 5px 40px;
        font-size: 20px;
    }
    .Main_containerSlots__7ADSj{
        padding: 10px;
    }
    .Main_containerName__yX5NX{
        font-size: 25px;
    }
    .Main_containerInf__tgFZj{
        /*margin-top: 30px;*/
    }
    .Main_containerImgs__SycFC img{
        width: 120px;
    }
    .Main_card__RSCgW {
        width: 45%;
    }
    .Main_containerBlocks__0aV1u {
        margin: 20px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/Pages/MainPage/Main.module.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,wBAAwB;IACxB,mBAAmB;IACnB,6BAA6B;IAC7B,uBAAuB;IACvB,6BAA6B;IAC7B,oBAAoB;IACpB,yBAAyB;IACzB,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,+BAA+B;IAC/B,0BAA0B;IAC1B,2BAA2B;AAC/B;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;;AAEZ;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;AACA;IACI,+BAA+B;IAC/B,oBAAoB;IACpB,iCAAiC;IACjC,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,eAAe;IACf;;AAEJ;AACA;IACI,4BAA4B;IAC5B,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,mCAAmC;IACnC,eAAe;IACf;;;;AAIJ;AACA;IACI,iBAAiB;AACrB;AACA;;;IAGI,aAAa;;IAEb,sBAAsB;IACtB,sBAAsB;IACtB,SAAS;;IAET,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,UAAU;IACV,mBAAmB;IACnB,mBAAmB;IACnB,2BAA2B;IAC3B,gBAAgB;IAChB,6BAA6B;IAC7B,aAAa;AACjB;AACA;IACI,aAAa;IACb,YAAY;IACZ,gCAAgC;IAChC,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,uBAAuB;IACvB,mBAAmB;IACnB,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,KAAK;IACL,MAAM;;IAEN,WAAW;IACX,YAAY;;IAEZ,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,yBAAyB;;IAEzB,gBAAgB;;;IAGhB,mBAAmB;;IAEnB,eAAe;IACf,aAAa;;;;;AAKjB;AACA;;IAEI,aAAa;IACb,uBAAuB;IACvB,QAAQ;IACR,UAAU;;AAEd;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,KAAK;IACL,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,UAAU;IACV,WAAW;AACf;AACA;IACI,YAAY;AAChB;;AAEA;;;IAGI,yBAAyB;;IAEzB,iBAAiB;IACjB,kBAAkB;;IAElB,gBAAgB;;IAEhB,YAAY;IACZ,gCAAgC;IAChC,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,eAAe;;IAEf,mBAAmB;IACnB,cAAc;;;;AAIlB;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,WAAW;IACX,qBAAqB;IACrB,UAAU;IACV,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,+BAA+B;IAC/B,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,YAAY;IACZ,+BAA+B,EAAE,qDAAqD;;;AAG1F;AACA;IACI,qBAAqB,EAAE,kDAAkD;AAC7E;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;;AAErB;AACA;IACI,YAAY;IACZ,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,QAAQ;;IAER,uBAAuB;AAC3B;AACA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;;AAEf;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB,eAAe;;IAEf,+BAA+B;IAC/B,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,eAAe;;IAEf,+BAA+B;IAC/B,gBAAgB;AACpB;;AAEA;;;IAGI,aAAa;IACb,uBAAuB;IACvB,WAAW;IACX,qBAAqB;IACrB,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,sBAAsB;IACtB,eAAe;IACf,sBAAsB;;IAEtB,gBAAgB;;AAEpB;;AAEA;IACI,gCAAgC;IAChC,gBAAgB;AACpB;AACA;IACI;QACI,WAAW;IACf;AACJ;AACA;IACI;QACI,WAAW;IACf;IACA;QACI,eAAe;IACnB;IACA;QACI,iBAAiB;IACrB;AACJ;AACA;IACI;QACI,WAAW;IACf;;AAEJ;AACA;IACI;QACI,gBAAgB;QAChB,cAAc;QACd,uBAAuB;QACvB,aAAa;QACb,iBAAiB;;IAErB;IACA;QACI,eAAe;IACnB;IACA;QACI,iBAAiB;QACjB,eAAe;IACnB;IACA;QACI,aAAa;IACjB;IACA;QACI,eAAe;IACnB;IACA;QACI,oBAAoB;IACxB;IACA;QACI,YAAY;IAChB;IACA;QACI,UAAU;IACd;IACA;QACI,YAAY;IAChB;AACJ","sourcesContent":["* {\r\n    box-sizing: border-box;\r\n}\r\n\r\n:root {\r\n    --icon-vk: #07f;\r\n    --icon-vk-hover: #006be5;\r\n    --icon-youtube: red;\r\n    --icon-youtube-hover: #e50000;\r\n    --icon-discord: #5865f2;\r\n    --icon-discord-hover: #4856f0;\r\n    --color-accent: #0af;\r\n    --color-background: white;\r\n    --stroke-width: calc(1em / 16);\r\n    --font-size: 10vmin;\r\n    --font-weight: 700;\r\n    --letter-spacing: calc(1em / 8);\r\n    --max_width_roulete: 999px;\r\n    --min_height_roulete: 600px;\r\n}\r\n.wrapperSection{\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap:10px;\r\n\r\n}\r\n.wrapperHeader{\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n}\r\n.wrapperHeader .buttonAll{\r\n    border:1px solid rgb(7, 196, 7);\r\n    color:rgb(9, 185, 9);\r\n    font-family: monospace,sans-serif;\r\n    padding: 10px;\r\n    border-radius: 10px;\r\n    cursor: pointer;\r\n    font-size: 16px;\r\n    transition: all 300ms cubic-bezier(0.420, 0.000, 0.580, 1.000)\r\n\r\n}\r\n.wrapperHeader .buttonAll:hover{\r\n    border:1px solid greenyellow;\r\n    color:greenyellow;\r\n    transform: scale(1.1);\r\n}\r\n\r\n.wrapperSection .header{\r\n    font-size: 25px;\r\n    font-family: monospace , sans-serif;\r\n    cursor: pointer;\r\n    transition: all 300ms cubic-bezier(0.420, 0.000, 0.580, 1.000)\r\n    \r\n\r\n\r\n}\r\n.wrapperSection .header:hover{\r\n    color:greenyellow;\r\n}\r\n.mainContainer {\r\n    \r\n\r\n    display: flex;\r\n\r\n    flex-direction: column;\r\n    padding: 0 30px 0 30px;\r\n    gap: 20px;\r\n\r\n    min-height: 100vh;\r\n}\r\n\r\n.card {\r\n    position: relative;\r\n    cursor: pointer;\r\n    display: flex;\r\n    flex-direction: column;\r\n    width: 24%;\r\n    aspect-ratio: 1 / 1;\r\n    border-radius: 10px;\r\n    border: 1px solid #ffffff40;\r\n    overflow: hidden;\r\n    transition: transform 1s ease;\r\n    padding: 20px;\r\n}\r\n.naming{\r\n    display: none;\r\n    color: white;\r\n    font-family: Poppins, sans-serif;\r\n    font-weight: 600;\r\n    font-size: 30px;\r\n}\r\n.containerBlocks {\r\n    margin-bottom: 70px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    flex-wrap: wrap;\r\n    justify-content: center;\r\n    align-items: center;\r\n    background: #ef00ff2e;\r\n    padding: 20px;\r\n    border-radius: 10px;\r\n    border: 1px solid #ffffff1c;\r\n}\r\n\r\n.card_image {\r\n    position: absolute;\r\n    top:0;\r\n    left:0;\r\n\r\n    width: 100%;\r\n    height: 100%;\r\n\r\n    overflow: hidden;\r\n}\r\n\r\n.containerSlots {\r\n    position: relative;\r\n    display: flex;\r\n    flex-direction: column;\r\n    background-color: #1d2354;\r\n\r\n    overflow: hidden;\r\n\r\n\r\n    border-radius: 10px;\r\n\r\n    cursor: pointer;\r\n    padding: 20px;\r\n\r\n\r\n\r\n\r\n}\r\n.containerImgs{\r\n\r\n    display: flex;\r\n    justify-content: center;\r\n    gap:10px;\r\n    z-index: 2;\r\n\r\n}\r\n.iconCompanyCard{\r\n    position: absolute;\r\n    right: 0;\r\n    top:0;\r\n    font-size: 40px;\r\n    color:greenyellow;\r\n    rotate: 45deg;\r\n    z-index: 2;\r\n    margin:10px;\r\n}\r\n.containerImgs img{\r\n    width: 200px;\r\n}\r\n\r\n.buttonEnter {\r\n\r\n\r\n    background-color: #710cff;\r\n\r\n    padding: 5px 50px;\r\n    text-align: center;\r\n\r\n    transition: 0.5s;\r\n\r\n    color: white;\r\n    font-family: Poppins, sans-serif;\r\n    letter-spacing: 0.1rem;\r\n    font-weight: 700;\r\n    font-size: 20px;\r\n    cursor: pointer;\r\n\r\n    border-radius: 10px;\r\n    display: block;\r\n\r\n\r\n\r\n}\r\n.buttonEnter.companyBlock{\r\n    position: absolute;\r\n    bottom: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    background: #000000c4;\r\n    z-index: 2;\r\n    font-size: 15px !important;\r\n    font-weight: 500;\r\n}\r\n\r\n.containerName {\r\n    color: white;\r\n    font-family: Gilroy, sans-serif;\r\n    font-weight: 600;\r\n    font-size: 30px;\r\n}\r\n\r\n.containerInf {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    z-index: 2;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.BgCont {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    object-fit: cover;\r\n    opacity: 0.2;\r\n    transition: transform 0.5s ease; /* добавляем плавный переход для свойства transform */\r\n\r\n\r\n}\r\n.containerSlots:hover .BgCont{\r\n    transform: scale(1.3); /* при наведении, увеличиваем изображение на 10% */\r\n}\r\n\r\n.card_image img {\r\n    width: 100%;\r\n    height: 100%;\r\n    object-fit: cover;\r\n\r\n}\r\n.imgSlot img{\r\n    width: 180px;\r\n    border-radius: 10px;\r\n}\r\n.wrapper{\r\n    display: flex;\r\n    gap:10px;\r\n\r\n    justify-content: center;\r\n}\r\n.containerCarosel{\r\n    overflow: hidden;\r\n    border-radius: 10px; \r\n    width: 100%;\r\n\r\n}\r\n\r\n.card_title {\r\n    padding: 10px;\r\n    background-color: #191d3e;\r\n    text-align: center;\r\n    font-weight: bold;\r\n    color: whitesmoke;\r\n    font-size: 30px;\r\n\r\n    font-family: Gilroy, sans-serif;\r\n    font-weight: 700;\r\n}\r\n\r\n.header {\r\n    display: flex;\r\n    color: whitesmoke;\r\n    font-size: 30px;\r\n\r\n    font-family: Gilroy, sans-serif;\r\n    font-weight: 700;\r\n}\r\n\r\n.button_enter_card {\r\n\r\n\r\n    display: flex;\r\n    justify-content: center;\r\n    color: #fff;\r\n    text-decoration: none;\r\n    text-transform: uppercase;\r\n    border-radius: 10px;\r\n    border: none;\r\n    letter-spacing: 0.1rem;\r\n    font-size: 1rem;\r\n    padding: 0.5rem 1.5rem;\r\n\r\n    transition: 0.2s;\r\n\r\n}\r\n\r\n.button_enter_card span {\r\n    font-family: Poppins, sans-serif;\r\n    font-weight: 700;\r\n}\r\n@media only screen and (max-width: 1700px) {\r\n    .imgSlot img{\r\n        width:140px;\r\n    }\r\n}\r\n@media only screen and (max-width: 1400px) {\r\n    .imgSlot img{\r\n        width:120px;\r\n    }\r\n    .containerName{\r\n        font-size: 20px;\r\n    }\r\n    .buttonEnter{\r\n        padding: 5px 25px;\r\n    }\r\n}\r\n@media only screen and (max-width: 1200px) {\r\n    .imgSlot img{\r\n        width:110px;\r\n    }\r\n    \r\n}\r\n@media only screen and (max-width: 1000px)  {\r\n    .mainContainer {\r\n        margin-top: 60px;\r\n        margin-left: 0;\r\n        justify-content: center;\r\n        padding: 10px;\r\n        /*padding: 20px;*/\r\n\r\n    }\r\n    .wrapper{\r\n        flex-wrap: wrap;\r\n    }\r\n    .buttonEnter{\r\n        padding: 5px 40px;\r\n        font-size: 20px;\r\n    }\r\n    .containerSlots{\r\n        padding: 10px;\r\n    }\r\n    .containerName{\r\n        font-size: 25px;\r\n    }\r\n    .containerInf{\r\n        /*margin-top: 30px;*/\r\n    }\r\n    .containerImgs img{\r\n        width: 120px;\r\n    }\r\n    .card {\r\n        width: 45%;\r\n    }\r\n    .containerBlocks {\r\n        margin: 20px;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapperSection": `Main_wrapperSection__t9h9q`,
	"wrapperHeader": `Main_wrapperHeader__T8FMl`,
	"buttonAll": `Main_buttonAll__JaDAF`,
	"header": `Main_header__hUhxT`,
	"mainContainer": `Main_mainContainer__WJ+1L`,
	"card": `Main_card__RSCgW`,
	"naming": `Main_naming__HTkHX`,
	"containerBlocks": `Main_containerBlocks__0aV1u`,
	"card_image": `Main_card_image__TsD8H`,
	"containerSlots": `Main_containerSlots__7ADSj`,
	"containerImgs": `Main_containerImgs__SycFC`,
	"iconCompanyCard": `Main_iconCompanyCard__kThTW`,
	"buttonEnter": `Main_buttonEnter__Nfve2`,
	"companyBlock": `Main_companyBlock__dpT2o`,
	"containerName": `Main_containerName__yX5NX`,
	"containerInf": `Main_containerInf__tgFZj`,
	"BgCont": `Main_BgCont__Mwui8`,
	"imgSlot": `Main_imgSlot__lEJmm`,
	"wrapper": `Main_wrapper__5oEWu`,
	"containerCarosel": `Main_containerCarosel__MgvRk`,
	"card_title": `Main_card_title__k3OKO`,
	"button_enter_card": `Main_button_enter_card__tAi9F`
};
export default ___CSS_LOADER_EXPORT___;
